import {
  ACTION_CREATE_SITE_FOOTER_LINK__REQUEST,
  ACTION_CREATE_SITE_FOOTER_LINK__SUCCESS,
  ACTION_CREATE_SITE_FOOTER_LINK__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CREATE_SITE_FOOTER_LINK__REQUEST:
    case ACTION_CREATE_SITE_FOOTER_LINK__SUCCESS:
      return null;

    case ACTION_CREATE_SITE_FOOTER_LINK__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
